import { activeUploadCountSelector, hasPausedUploadsSelector, uploaderIsUploadingSelector } from '@air/redux-uploader';

import { useAirSelector } from '~/utils/ReduxUtils';

export type WorkspaceUploadsInProgressCounts = {
  hasInProgressUploads: boolean;
  hasProgressingUploads: boolean;
  inProgressCount: number;
  isPaused: boolean;
};

export const useWorkspaceUploadsInProgressCounts = (): WorkspaceUploadsInProgressCounts => {
  const inProgressCount = useAirSelector(activeUploadCountSelector);
  const hasProgressingUploads = useAirSelector(uploaderIsUploadingSelector);
  const hasPausedUploads = useAirSelector(hasPausedUploadsSelector);
  const hasInProgressUploads = inProgressCount > 0;

  return {
    hasInProgressUploads,
    hasProgressingUploads,
    inProgressCount,
    isPaused: hasPausedUploads && !hasProgressingUploads,
  };
};
